<template>
  <div class="smart-voice" @click="onClickDialog">
    <svg
      aria-hidden="true"
      style="position: absolute; width: 0px; height: 0px; overflow: hidden"
    >
      <symbol id="icon-test-play" viewBox="0 0 1024 1024">
        <!-- <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#5778FB" p-id="3226"></path> -->
        <circle id="gfg"
                cx="512"
                cy="512"
                r="512"
                fill="#5778FB"/>
        <path d="M398.222222 307.768889v408.462222c0 19.911111 29.013333 30.72 47.217778 17.635556l284.444444-204.231111a20.48 20.48 0 0 0 0-34.702223l-284.444444-204.8c-18.204444-13.084444-47.217778-2.275556-47.217778 17.635556z" fill="#FFFFFF" p-id="3227"></path>
      </symbol>
      <symbol id="icon-test-pause" viewBox="0 0 1024 1024">
        <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#5778FB" p-id="9434"></path><path d="M369.777778 284.444444m42.666666 0l0 0q42.666667 0 42.666667 42.666667l0 369.777778q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666666-42.666667l0-369.777778q0-42.666667 42.666666-42.666667Z" fill="#FFFFFF" p-id="9435"></path><path d="M568.888889 284.444444m42.666667 0l0 0q42.666667 0 42.666666 42.666667l0 369.777778q0 42.666667-42.666666 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-369.777778q0-42.666667 42.666667-42.666667Z" fill="#FFFFFF" p-id="9436"></path>
      </symbol>
      <symbol id="icon-add" viewBox="0 0 1024 1024">
        <path d="M874.02508 149.983892a511.985067 511.985067 0 1 0 0 724.032216 511.985067 511.985067 0 0 0 0-724.032216z m-361.973443 725.312179a71.251255 71.251255 0 0 1-71.037928-71.123259v-221.177549H219.921491a71.037928 71.037928 0 0 1 0-142.075856h221.092218V219.869854a71.037928 71.037928 0 1 1 142.075857 0v221.049553h221.049552a71.037928 71.037928 0 1 1 0 142.075856h-221.049552v221.092218a71.336586 71.336586 0 0 1-71.037929 71.165924z" p-id="1762"></path>
      </symbol>
    </svg>
    <div class="backdrop" :style="backdropStyle" @click="close"></div>
    <div class="dialog" ref="dialogEl" :style="dialogStyle">
      <smartVoiceContent></smartVoiceContent>
    </div>
  </div>
</template>

<script>
import smartVoiceContent from './smartVoice/smartVoiceContent.vue';
export default {
  components: {
    smartVoiceContent
  },
  data () {
    return {
      dialogRect: {
        top: 0,
        left: 0
      },
      backdropRect: {
        width: 0,
        width: 0
      }
    }
  },
  computed: {
    dialogStyle () {
      return {
        top: this.dialogRect.top + 'px',
        left: this.dialogRect.left + 'px'
      }
    },
    backdropStyle () {
      return {
        width: this.backdropRect.width + 'px',
        height: this.backdropRect.height + 'px'
      }
    }
  },
  mounted () {
    this.updateRects();
    window.addEventListener('resize', this.updateRects);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateRects);
  },
  methods: {
    onClickDialog () {
      this.$bus.emit('smartVoice.clickDialog')
    },
    close () {
      this.$emit('close');
    },
    setDialogRect () {
      let docEl = document.documentElement;
      let dialogEl = this.$refs.dialogEl;
      let top = (docEl.offsetHeight - dialogEl.offsetHeight) / 2;
      let left = (docEl.offsetWidth - dialogEl.offsetWidth) / 2;
      this.dialogRect = {
        top,
        left
      }
    },
    setBackdropRect () {
      let docEl = document.documentElement;
      let width = docEl.offsetWidth;
      let height = docEl.offsetHeight;
      this.backdropRect = {
        width,
        height
      }
    },
    updateRects () {
      this.setDialogRect();
      this.setBackdropRect();
    }
  }
}
</script>

<style lang="scss" scoped>
.smart-voice {
  position: absolute;
  top: 0;
  left: 0;
}
.backdrop {
  background-color: rgba(#000, 0.6);
}
.dialog {
  position: absolute;
  width: 946px;
  height: 569px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoiceDialog.vue